/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountPassword.defs.js'
export * as $defs from './updateAccountPassword.defs.js'
